__turbopack_context__.v({
  "callToAction": "styles-module__BuZvnW__callToAction",
  "container": "styles-module__BuZvnW__container",
  "feature": "styles-module__BuZvnW__feature",
  "featureList": "styles-module__BuZvnW__featureList",
  "header": "styles-module__BuZvnW__header",
  "label": "styles-module__BuZvnW__label",
  "signUpButton": "styles-module__BuZvnW__signUpButton",
  "title": "styles-module__BuZvnW__title",
});
